import React from "react";

const Container = ({
  children,
  className = "",
  shouldIgnoreContainerStyle = false,
}) => {
  return (
    <div
      className={` ${
        !shouldIgnoreContainerStyle ? "custom-container" : ""
      }  ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
